module.exports = __webpack_public_path__ + "static/img/egg_g_06.63bffa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_06.png
// module id = aMt+
// module chunks = 1